import { type SectionConfig } from '@/utils/get-matched-section'

export const sectionConfig: SectionConfig = {
  '/portal/dashboard': {
    title: (_params, org) =>
      (org as { name?: string })?.name
        ? `${(org as { name: string }).name} Dashboard`
        : 'Dashboard'
  },
  '/portal/properties': {
    title: 'Properties'
  },
  '/portal/support/cases': {
    title: 'Cases'
  },
  '/portal/proposals': {
    title: 'Proposals'
  },
  '/portal/deployments': {
    title: 'Deployments'
  },
  '/portal/engagement': {
    title: 'Engagement'
  },
  '/portal/[id]/overview': {
    fullBleed: true,
    title: 'Overview'
  },
  '/portal/[id]/support/cases': {
    title: 'Cases'
  },
  '/portal/[id]/support/cases/[caseId]': {
    fullBleed: true,
    title: (params) => (params as { caseId?: string }).caseId ?? 'Case',
    parentBreadcrumb: {
      label: 'Cases',
      href: (params, orgSlug, customerId) =>
        `/${orgSlug}/portal/${customerId}/support/cases`
    }
  },
  '/portal/[id]/proposals': {
    title: 'Proposals'
  },
  '/portal/[id]/deployments': {
    title: 'Deployments'
  },
  '/portal/[id]/networking/overview': {
    title: 'Networking'
  },
  '/portal/[id]/networking/topology': {
    fullBleed: true,
    title: 'Network Topology'
  },
  '/portal/[id]/networking/access-points': {
    title: 'Access Points'
  },
  '/portal/[id]/networking/switches': {
    title: 'Switches'
  },
  '/portal/[id]/networking/appliances': {
    title: 'Appliances'
  },
  '/portal/[id]/tv-experience/channels': {
    title: 'Channels'
  },
  '/portal/[id]/tv-experience/guide': {
    title: 'Guide'
  },
  '/portal/[id]/tv-experience/displays': {
    title: 'Displays'
  },
  '/portal/[id]/tv-experience/cable-modems': {
    title: 'Cable Modems'
  },
  '/portal/[id]/tv-experience/casting': {
    title: 'Casting'
  },
  '/portal/[id]/tv-experience/app-settings': {
    title: 'App Settings'
  },
  '/portal/[id]/tv-experience/live-view': {
    fullBleed: true,
    title: 'Live View'
  },
  '/portal/[id]/engagement/promotions': {
    title: 'Promotions'
  },
  '/portal/[id]/engagement/house-channels': {
    title: 'House Channels'
  },
  '/portal/[id]/engagement/playlists': {
    title: 'Playlists'
  },
  '/portal/[id]/engagement/media': {
    title: 'Media Library'
  },
  '/portal/[id]/rooms': {
    fullBleed: true,
    title: 'Rooms View'
  },
  '/portal/[id]/reports': {
    title: 'Reports'
  },
  '/portal/[id]/documentation': {
    fullBleed: true,
    title: 'Documentation'
  },
  '/portal/[id]/vendors': {
    title: 'Vendors'
  },
  '/portal/[id]/vendors/[vendorId]': {
    title: (_params, entityData) => {
      const data = entityData as { name?: string } | undefined
      return data?.name ?? 'Vendor'
    },
    parentBreadcrumb: {
      label: 'Vendors',
      href: (params, orgSlug, customerId) =>
        `/${orgSlug}/portal/${customerId}/vendors`
    }
  },
  '/portal/vendors': {
    title: 'Vendors'
  },
  '/portal/members': {
    title: 'Members',
    description: "Your organization's members and their portal roles."
  },
  '/portal/groups': {
    title: 'Groups',
    description: "Your organization's groups and who is in them."
  },
  '/portal/groups/[groupId]': {
    title: 'Group Info',
    parentBreadcrumb: {
      label: 'Groups',
      href: (_params, orgSlug) => `/${orgSlug}/portal/groups`
    }
  },
  '/portal/groups/[groupId]/members': {
    title: 'Group Members',
    parentBreadcrumb: {
      label: 'Groups',
      href: (_params, orgSlug) => `/${orgSlug}/portal/groups`
    }
  },
  '/portal/invitations': {
    title: 'Invitations',
    description: 'Pending invitations to your organization.',
    parentBreadcrumb: {
      label: 'Members',
      href: (_params, orgSlug) => `/${orgSlug}/portal/members`
    }
  },
  '/portal/vendors/new': {
    title: 'New Vendor',
    parentBreadcrumb: {
      label: 'Vendors',
      href: (_params, orgSlug) => `/${orgSlug}/portal/vendors`
    }
  },
  '/portal/vendors/[vendorId]': {
    title: (_params, entityData) => {
      const data = entityData as { name?: string } | undefined
      return data?.name ?? 'Vendor'
    },
    parentBreadcrumb: {
      label: 'Vendors',
      href: (_params, orgSlug) => `/${orgSlug}/portal/vendors`
    }
  }
}
